import { createStyles, rem } from "@mantine/core";

export const useStyles = createStyles(() => ({
  nextDueFilter: {
    maxWidth: rem(584),
    width: "100%",
  },
}));
